export interface SchedulingTeamContact {
  id?: string;
  name: string;
  email?: string;
  phone?: string;
  role?: string;
  doNotContact: boolean;
}

export interface Board {
  id?: string;
  name: string;
}

export interface SchedulingTeamDriver {
  id?: string;
  driverId: string;
  name?: string;
  lastName?: string;
  driverNo?: string;
  boardId?: string;
  boardName?: string;
  billToClientId?: string;
  billToClientName?: string;
}

export interface SchedulingTeam {
  id?: string;
  dateCreatedUtc?: Date;
  name: string;
  clientId: string;
  clientName?: string;
  clientCustomerTraining?: string;
  contacts: SchedulingTeamContact[];
  boards: Board[];
  drivers: SchedulingTeamDriver[];
}

export interface UnassignedDriver {
  id: string;
  name?: string;
  lastName?: string;
  driverNo?: string;
  displayName: string;
}

export interface BillToClient {
  id: string;
  companyName: string;
  clientId: string; // Parent client ID - bill-to clients belong to a parent client
}